import { Building } from '../models/building.model';
import { Action } from '@ngrx/store';

// Define Action Types
export const ADD_BUILDING = '[Building] Add';
export const UPDATE_BUILDING = '[Building] Update';
export const JOIN_BUILDING = '[Building] Join';
export const ADD_BUILDING_IMAGE = '[Building] Add Building Image';
export const ADD_PROFILE_IMAGE = '[Building] Add Profile Image';
export const ADD_GROUP_IMAGE = '[Building] Add Group Image';
export const RESET = '[Building] Reset';
export const IMAGE_RESET = '[Building] Image Reset';
export const BUILDING_OVERRIDE = '[Building] Override';
export const ADD_ACCOUNT_IMAGE = 'ADD_ACCOUNT_IMAGE';
interface BuildingAction extends Action {
  payload?: any;  // Defining payload as optional because not every action might need it
}

// Initial State
const initialState: any[] = [{
  address: {
    coords: { lat: 40.7230343, lng: -73.9991738 }
  },
  newBuilding: false,
  image: { building: null, profile: null, group: null },
  buildingName: null
}];

var image = { building: null, profile: null, group: null };

// Reducer Function
export function buildingReducer(state: any[] = initialState, action: BuildingAction) {
  console.log('::reducer=>',action)
  switch (action.type) {
    case ADD_BUILDING:
      action.payload.newBuilding = true;
      action.payload.image = image.building == null ? { building: null, profile: null } : { building: image, profile: null };
      return [action.payload];  // Ensure you use a new array for immutability

    case UPDATE_BUILDING:
      state[0].address.buildingName = action.payload.buildingName;
      if (action.payload.isCancelled) {
        state[0].isCancelled = true;
      }
      return state.slice();  // Use spread operator to return a new state array

    case JOIN_BUILDING:
      action.payload.newBuilding = false;
      action.payload.image = image;
      console.log('JOIN_BUILDING reducer hit', action.payload);
    //    return [
    // { ...action.payload, newBuilding: false, image }
      return [action.payload];

    case ADD_BUILDING_IMAGE:
      image = action.payload.image;
      state[0].image.building = action.payload.image;
      return state.slice();

    case ADD_PROFILE_IMAGE:
      state[0].image.profile = action.payload.image;
      return state.slice();

    case ADD_GROUP_IMAGE:
      state[0].image.group = action.payload.image;
      return state.slice();

    case ADD_ACCOUNT_IMAGE:
      state[0].image.profile = action.payload.image;
      return state.slice();

    case RESET:
      return [{
        address: { coords: { lat: 40.7230343, lng: -73.9991738 } },
        newBuilding: false,
        image: { building: null, profile: null, group: null },
        buildingName: null
      }];

    case IMAGE_RESET:
      state[0].image.building = null;
      return state.slice();

    case BUILDING_OVERRIDE:
      return [action.payload];

    default:
      return state;
  }
}